import { logAmplitudeEvent } from 'amplitude/amplitude'
import { ComponentVersions_3_0 } from 'constants/uxVersions'
import { orgSelectors } from 'ducks/orgs'
import { DistributorTradePricingContext } from 'elements/hardwareSelectorV2/HardwareSelectorCore'
import { ComponentVersionsInherit } from 'opensolar-ui'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import useDistributorTradePricing from 'services/useDistributorTradePricing'
import { useFeatureFlag } from 'util/featureFlags'
import ProductDetail3 from '../detailsv3/ProductDetail3'
import ShopPageContainer from '../elements/ShopPageContainer'
import useEnabledHardwareSuppliers from '../hooks/useEnabledHardwareSuppliers'
import ProductDetailProviderV2 from './ProductDetailProviderV2'

const ProductDetailPage = ({ componentCode }: { componentCode: string }) => {
  useEffect(() => {
    logAmplitudeEvent('page_viewed', {
      page: 'product_detail',
    })
  }, [])
  const { filteredSuppliers: hardwareDistributors } = useEnabledHardwareSuppliers()

  const { distributorTradePricing, isChecking } = useDistributorTradePricing({
    orgId: useSelector(orgSelectors.getOrg)?.id || 0,
    distributors: hardwareDistributors,
  })

  const enabledHardwareShopV3 = useFeatureFlag('enable_multi_distributor_shop', 'on')

  return (
    <ShopPageContainer surfaceColor={enabledHardwareShopV3 ? undefined : null} disableVerticalPadding>
      {enabledHardwareShopV3 ? (
        <DistributorTradePricingContext.Provider value={{ distributorTradePricing, isChecking }}>
          <ComponentVersionsInherit versions={ComponentVersions_3_0}>
            <ProductDetail3 componentCode={componentCode} />
          </ComponentVersionsInherit>
        </DistributorTradePricingContext.Provider>
      ) : (
        <ProductDetailProviderV2 componentCode={componentCode} />
      )}
    </ShopPageContainer>
  )
}

export default ProductDetailPage
